import { defineComponent as _defineComponent } from 'vue'
import StoreFileBlobList from '../components/StoreFileBlobList.vue';
import router from '../router/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreFileBlobsView',
  setup(__props) {


const breadcrumbItems = [
  {
    text: 'Stores',
    disabled: false,
    href: router.match({
      name: 'stores',
    }).path,
  },
  {
    text: router.currentRoute.params.store,
    disabled: false,
    href: router.match({
      name: 'storeFiles',
      params: {
        store: router.currentRoute.params.store,
      },
    }).path,
  },
  {
    text: router.currentRoute.params.file,
    disabled: false,
    href: router.match({
      name: 'storeFileBlobs',
      params: {
        store: router.currentRoute.params.store,
        file: router.currentRoute.params.file,
      },
    }).path,
  },
]



return { __sfc: true,breadcrumbItems, StoreFileBlobList }
}

})